import styled from 'styled-components';
import { Input } from 'antd';

export const InputPasswordRemoveIcon = styled(Input.Password)`
  .ant-input-suffix {
    display: ${(props) => props?.displayicon || 'flex'};
  }
  height: 40px;
`;
